import React from 'react';
import { useJournalContext } from '../../contexts/journal.tsx';
import FormatDate from '../../models/helpers/formatDate.ts';

const JournalHeader = () => {
    const { searchParam, setSearchParam } = useJournalContext();

    const handleDateChange = (e) => {
        const newDate = e.target.value;
        setSearchParam((prev) => ({
            ...prev,
            dateTime: new Date(newDate),
        }));
    };

    return (
        <div className="d-flex flex-row justify-content-between">
            <h1>Journal</h1>
            <input
                type="date"
                className="form-control my-auto"
                style={{
                    padding: 0,
                    width: "min-content",
                    height: "min-content"
                }}
                value={FormatDate(searchParam.dateTime)}
                onChange={handleDateChange} />
        </div>
    );
};

export default JournalHeader;
